/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Prerequisite } from "~/models/prerequisite";
import { Log } from "./log";

export type ServiceCommitment = {
  description: string;
  id: string;
  log: Log;
  name: string;
  version: string;
  owner?: {
    id: string;
    email: string;
  };
  pricingType: string;
  prerequisites: Array<Prerequisite>;
  serviceLevel?: {
    id: string;
    name: string;
  };
  processType?: string;
  serviceLines?: Array<string>;
};

export const serviceInitialState: ServiceCommitment = {
  description: "",
  id: "",
  log: {
    created: {
      author: "",
      time: "",
    },
    modified: {
      author: "",
      time: "",
    },
  },
  name: "",
  version: "",
  owner: {
    id: "",
    email: "",
  },
  pricingType: "",
  prerequisites: [
    {
      text: "",
      id: "",
    },
  ],
  serviceLevel: {
    id: "",
    name: "",
  },
  processType: "",
  serviceLines: [""],
};

export type ServiceCmtSmall = {
  id: string;
  name: string;
  pricingType: string;
  version: string;
};

export type Prerequisites = {
  text: string;
};
